import { render, staticRenderFns } from "./IntelligentDiagnosis.vue?vue&type=template&id=ad5a4178&scoped=true"
import script from "./IntelligentDiagnosis.vue?vue&type=script&lang=js"
export * from "./IntelligentDiagnosis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad5a4178",
  null
  
)

export default component.exports